"use strict";

exports.__esModule = true;
exports.CircleIconWrapper = exports.CircleIconFigure = exports.CircleIconContentWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const formatSize = size => {
  return isNaN(size) ? size : `${size}px`;
}; // note: destructure the custom props so that they don't get rendered in the DOM


const CircleIconFigure = (0, _styledComponents.default)(({
  icon,
  size,
  error,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("figure", { ...props
}))`
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  width: ${props => props.size ? formatSize(props.size) : "80px"};
  height: ${props => props.size ? formatSize(props.size) : "80px"};
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.circleIcon.background};
  border: 2px solid ${props => props.theme.colors.circleIcon.border};
  border-radius: 50%;
  margin: 0;
  padding: 0;

  ${props => props.error && (0, _styledComponents.css)`
      background-color: ${props => props.theme.colors.circleIcon.error.background};
      border: 2px solid ${props => props.theme.colors.circleIcon.error.border};
    `}

  ${props => props.outline && (0, _styledComponents.css)`
      background-color: ${props => props.theme.colors.transparent};
    `}

    svg {
    max-width: 100%;
    height: auto;
  }

  ${_styledSystem.space}
  ${_styledSystem.layout}
    ${_styledSystem.color}
    ${_styledSystem.position}
`;
exports.CircleIconFigure = CircleIconFigure;
const CircleIconWrapper = _styledComponents.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
exports.CircleIconWrapper = CircleIconWrapper;
const CircleIconContentWrapper = _styledComponents.default.div`
  display: inline-block;
  position: relative;
  width: 58%;
  text-align: center;

  ${_styledSystem.layout}
  ${_styledSystem.position}
`;
exports.CircleIconContentWrapper = CircleIconContentWrapper;